import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ChevronLeftIcon } from '../../assets';
import { Button } from '../Button';

export interface IGoBackButtonProps {
    onClick?: () => void;
}

export const GoBackButton = ({ onClick }: IGoBackButtonProps) => {
    const navigate = useNavigate();
    const handleGoBack = () => {
        if (onClick) {
            onClick();
            return;
        }
        navigate(-1);
    };

    return (
        <Button variant="fab" rounded="full" size="small" color="light" onClick={handleGoBack}>
            <ChevronLeftIcon />
        </Button>
    );
};
